import { Group, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Dot } from "../../delivery/atoms"

interface Props {
  /** DELIVERING with a GPS fix inside the live window (BE active-stats definition, O107). */
  isLive: boolean
  /** Last GPS fix label («N мин өмнө» / «Сүүлд YYYY-MM-DD»), null when there was never a fix. */
  lastSeenLabel?: string | null
  eta?: string | null
  stopProgress?: string | null
}

export function GpsStatusCell({ isLive, lastSeenLabel, eta, stopProgress }: Props) {
  const { t } = useTranslation("delivery")
  const label = isLive ? t("manage.active.live", { ago: lastSeenLabel }) : lastSeenLabel ?? t("manage.active.notStarted")
  return (
    <Stack gap={2} miw={0}>
      <Group gap={6} wrap="nowrap" align="center" miw={0}>
        <Dot tone={isLive ? "green" : lastSeenLabel ? "amber" : "grey"} />
        <Text fz="var(--nw-fz-body)" truncate="end" title={label}>
          {label}
        </Text>
      </Group>
      {stopProgress && (
        <Text fz="var(--nw-fz-body)" c="var(--nw-text-2)">
          {stopProgress}
        </Text>
      )}
      {eta && (
        <Text fz="var(--nw-fz-body)" c="var(--nw-text-2)" truncate="end">
          {t("manage.active.eta", { time: eta })}
        </Text>
      )}
    </Stack>
  )
}
